import React, { useRef } from 'react';
import ReactDOM from "react-dom";
import { useStoreState } from "easy-peasy";
import {useTranslation} from "react-i18next";

function GeneralFanFlowTitle() {
  const { t } = useTranslation();

  const currentFrequency = useStoreState(state => state.selection.designPoint.frequency);
  const fanFrequency = useStoreState(state => state.selection.fan.frequency);

  /* Reuse same ref on every render
   * https://github.com/facebook/react/issues/15110
   */
  const menuRef = useRef(null);

  if (!menuRef.current) {
    // Create once
    menuRef.current = document.getElementById("general-fan-flow-title");
    menuRef.current.innerHTML = "";
  }

  const domElement = menuRef.current;
  const frequency_warning = fanFrequency !== currentFrequency ? `(${fanFrequency}Hz)` : "";

  return ReactDOM.createPortal(
      <span>
        { t('frontend:fan.max_flow') } {frequency_warning}
      </span>
    , domElement
  );
}

export default GeneralFanFlowTitle;
